// extracted by mini-css-extract-plugin
export default {"revenueCards":"styles_revenueCards__iPQZU","connectTitle":"styles_connectTitle__yu7yF"};